import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "flex flex-col mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ClassroomTable = _resolveComponent("ClassroomTable")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Agenda = _resolveComponent("Agenda")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.showCalendar)
      ? (_openBlock(), _createBlock(_component_ClassroomTable, {
          key: 0,
          onUpdateClass: _ctx.updateClass
        }, {
          header: _withCtx(() => [
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t("labels.generic", { pt: "Turmas", en: "Classes" })), 1)
          ]),
          _: 1
        }, 8, ["onUpdateClass"]))
      : _createCommentVNode("", true),
    (_ctx.showCalendar)
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          _createVNode(_component_Agenda, {
            formVisible: _ctx.formVisible,
            "onUpdate:formVisible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formVisible) = $event))
          }, {
            header: _withCtx(() => [
              _createElementVNode("span", _hoisted_2, [
                _createVNode(_component_Button, {
                  class: "btn-simple flex gap-4 !px-0",
                  onClick: _withModifiers(_ctx.backTableClass, ["prevent"])
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      name: "co-arrow-left",
                      width: "24",
                      height: "24"
                    }),
                    _createElementVNode("h4", null, _toDisplayString(_ctx.$t("labels.generic", {
                  pt: `Calendário de aulas: ${_ctx.classSelected.name}`,
                  en: `Classes calendar: ${_ctx.classSelected.name}`,
                })), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_Button, {
                  label: 
              _ctx.$t('labels.generic', { pt: 'Adicionar aula', en: 'Add class' })
            ,
                  icon: "pi pi-plus",
                  class: "btn-primary p-button-sm",
                  onClick: _ctx.showForm
                }, null, 8, ["label", "onClick"])
              ])
            ]),
            _: 1
          }, 8, ["formVisible"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}